import { render, staticRenderFns } from "./BottomDialog.vue?vue&type=template&id=52c64df1&scoped=true&"
import script from "./BottomDialog.vue?vue&type=script&lang=js&"
export * from "./BottomDialog.vue?vue&type=script&lang=js&"
import style0 from "./BottomDialog.vue?vue&type=style&index=0&id=52c64df1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c64df1",
  null
  
)

export default component.exports